import { HttpStatusCode } from "../lib/HttpStatusCode";
import { SecKy } from "../lib/SecKy";

const endpoint = "/api/email";
// const makeQuery = (suffix, page, size) => `${(suffix ? suffix + '/' : '')}${endpoint}?page=${page || 1}&size=${size || 50}`;

function getDefaultState() {
  return {
    data: []
  };
}

const state = getDefaultState();

const actions = {
  reset({ commit }) {
    commit('mReset');
  },

  async getEmailPreview({ commit, rootState, state, dispatch }, commUID, reload) {
    const existingEmail = state.data.find(x => x.key == commUID);
    if (existingEmail && !reload)
        return existingEmail;

    let query = `${endpoint}?commUID=${commUID}`;
    
    var result = await SecKy.get(query);

    if (!result.success && result.httpStatusCode == HttpStatusCode.UNAUTHORIZED){
        await dispatch("user/reapplyToken", null, { root: true });
        if (!rootState.user.token) {
            console.log(result.error);
            return;
        }
        result = await SecKy.get(query);
    }

    console.log(result.payload);
    result.payload.commUID = commUID;

    commit("mSet", result.payload);
    return state.data.find(x => x.key == commUID);
  },
  async sendNow({rootState, dispatch}, instantEmailVm) {
    console.log("sendNow run");

    instantEmailVm.userEmail = rootState.user.email;
    var result = await SecKy.post(endpoint, {json: instantEmailVm});

    
    if (!result.success && result.httpStatusCode == HttpStatusCode.UNAUTHORIZED){
        await dispatch("user/reapplyToken", null, { root: true });
        if (!rootState.user.token) {
            console.log(result.error);
            return;
        }
        result = await SecKy.post(endpoint, {json: instantEmailVm});
    }
    
    console.log(result);
    return result.success;
  }
};


const mutations = {
  mReset(state) {
    Object.assign(state, getDefaultState());
  },
  mSet(state, payload) {
    state.data.push({key: payload.commUID, value: payload.data});
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
